<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M5.9987 11.3346H4.66536C3.78131 11.3346 2.93346 10.9834 2.30834 10.3583C1.68322 9.7332 1.33203 8.88536 1.33203 8.0013C1.33203 7.11725 1.68322 6.2694 2.30834 5.64428C2.93346 5.01916 3.78131 4.66797 4.66536 4.66797H5.9987"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10 4.66797H11.3333C12.2174 4.66797 13.0652 5.01916 13.6904 5.64428C14.3155 6.2694 14.6667 7.11725 14.6667 8.0013C14.6667 8.88536 14.3155 9.7332 13.6904 10.3583C13.0652 10.9834 12.2174 11.3346 11.3333 11.3346H10"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M5.33203 8H10.6654"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconLink',
	props: {
		size: {
			type: [Number, String],
			default: 16
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.33333
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedStroke() {
			return this.color
		}
	}
}
</script>
